import api from './auth';

// Get all categories
export const getAllCategories = async () => {
    try {
        const response = await api.get('/api/categories');
        return response;
    } catch (error) {
        console.error('Error fetching categories:', error);
        throw error;
    }
};

// Get category by ID
export const getCategoryById = async (id) => {
    try {
        const response = await api.get(`/api/categories/${id}`);
        return response;
    } catch (error) {
        console.error('Error fetching category:', error);
        throw error;
    }
};

// Admin category management functions
export const createCategory = async (categoryData) => {
    try {
        const response = await api.post('/api/admin/categories', categoryData);
        return response;
    } catch (error) {
        console.error('Error creating category:', error);
        throw error;
    }
};

export const updateCategory = async (id, categoryData) => {
    try {
        const response = await api.put(`/api/admin/categories/${id}`, categoryData);
        return response;
    } catch (error) {
        console.error('Error updating category:', error);
        throw error;
    }
};

export const deleteCategory = async (id) => {
    try {
        const response = await api.delete(`/api/admin/categories/${id}`);
        return response;
    } catch (error) {
        console.error('Error deleting category:', error);
        throw error;
    }
};

export const getAllCategoriesForAdmin = async () => {
    try {
        const response = await api.get('/api/admin/categories');
        return response;
    } catch (error) {
        console.error('Error fetching admin categories:', error);
        throw error;
    }
};
